import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/MemberDetails.css'; 
import '../styles/CashRequestHistory.css'
import { MdAccessTime, MdDateRange, MdOutlineModeEditOutline } from 'react-icons/md';
import Select from 'react-select';


function AgentCashRequestHistory() {

    const [currentPage, setCurrentPage] = useState(1);
    const location = useLocation();
    const [selectedRequest, setSelectedRequest] = useState(null);
    // const [requests, setRequests] = useState(
    //   useLocation().state?.customer?.request || []
    // );
    const agent = location.state?.agent;
    const navigate = useNavigate();
    const itemsPerPage = 6;

    const [requests, setRequests] = useState(agent?.requests || []);
    const [agentData, setAgentData] = useState(location.state?.agent || { requests: [] });

    

    const goToWallet = () => {
      navigate('/agent-wallet-details', {state: {agent: agentData}})
    }

    const goToRequestHistory = () => {
        navigate('/agent-cash-request-history', {state: {agent: agentData}})
    }

    const goToAgentDetails = () => {
        navigate('/agent-details', {state: {agent: agentData}})
    }

    const totalPages = Math.ceil(requests.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedAgent = requests.slice(startIndex, startIndex + itemsPerPage);

    // handle modal open
    const handleRowClick = (req, index) => {
      setSelectedRequest({
        ...req,
        index,
        agentValue: agentData.value, // add the total value here
      });
    };

    // handle input change in modal
    // Handle input changes in modal
    const handleInputChange = (e) => {
      const { name, value } = e.target;

      setSelectedRequest((prev) => {
        let updatedRequest = { ...prev, [name]: value };

        // Auto update approved date/time when status = "Approved"
        if (name === "status" && value.toLowerCase() === "approved") {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const day = String(now.getDate()).padStart(2, "0");
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");

          updatedRequest.approvedDate = `${year}/${month}/${day}`;
          updatedRequest.approvedTime = `${hours}:${minutes}`;
        }

        return updatedRequest;
      });
    };

    // Save changes
    const handleUpdate = () => {
      const updatedRequests = [...requests];
      updatedRequests[selectedRequest.index] = selectedRequest;

      // Update table
      setRequests(updatedRequests);

      // Overwrite original customer data
      setAgentData((prev) => ({
        ...prev,
        requests: updatedRequests
      }));

      setSelectedRequest(null);
    };

    const handleCancel = () => {
      setSelectedRequest(null);
    }



  return (
    <div className="member-details-layout">
      <SideBar />

        <div className="member-details-main">

            {/* Header */}
            <div className="details-header">
                <h2>Agent Details</h2>
                <p>You can edit your details to update your profile</p>
            </div>

            {/* Breadcrumb */}
            <div className="breadcrumb">
                <Link to="/dashboard" className="breadcrumb-link">Home</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <Link to="/manage-agent" className="breadcrumb-link">Manage Retail Advertising Business Agent</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <span className="breadcrumb-current">Agent Details</span>
            </div>

            {/* buttons */}
            <div className="top-bar">
            {/* tap buttons */}
                <div className="top-buttons">
                    <button className="tab-btn" onClick={goToAgentDetails}>Personal Details</button>
                    <button className="tab-btn" onClick={goToWallet}>Wallet Details</button>
                    <button className="tab-btn active" onClick={goToRequestHistory}>Cash Request History</button>
                </div>
            </div>

            <div className="table-container">
              <table className="member-table">
                <thead>
                  <tr>
                    <th>Request Data</th>
                    <th>Approved Data</th>
                    <th>Amount</th>
                    <th>Status</th>
                    {/* <th></th> */}
                  </tr>
                </thead>
                <tbody>
                  {paginatedAgent.length > 0 ? (
                    paginatedAgent.map((req, i) => (
                      <tr 
                        key={i}
                        onClick={() => handleRowClick(req, startIndex + i)}
                        // onClick={() => handleRowClick(customer)}
                      >
                        <td>{req.requestDate}</td>
                        {/* <td>{req.approvedDate}</td> */}
                        <td>
                          <span className={`approve ${req.approvedDate.toLowerCase()}`}>{req.approvedDate}</span>
                        </td>
                        {/* <td>{req.amount}</td> */}
                        <td>
                          € {(() => {
                            const num = parseFloat(agentData.value);
                            return isNaN(num) ? "" : (num * 0.005).toFixed(2);
                          })()}
                        </td>
                        <td>
                          <span className={`status ${req.status.toLowerCase()}`}>{req.status}</span>
                        </td>
                        {/* <td>
                          <MdOutlineTouchApp className="icon-cell" />
                        </td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        No requests found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination">
                  <button className="page-btn" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}>
                    &lt;
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <button
                      key={i}
                      className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}
                  <button className="page-btn" onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}>
                    &gt;
                  </button>
                </div>
              )}
            </div> 
        </div> 
        {/* modal */}
        {selectedRequest && (
          <div className="modal-overlay">
            <div className="modal">
              <h3>Edit Status</h3>
              <label className="input-with-icon">
                Request Date:
                <div className="input-icon-wrapper">
                  <input type="text" value={selectedRequest.requestDate} readOnly />
                  <MdDateRange className="input-icon" />
                </div>
              </label>
              <label className="input-with-icon">
                Approve Date:
                <div className="input-icon-wrapper">
                  <input
                    type="text"
                    name="approvedDate"
                    value={selectedRequest.approvedDate}
                    onChange={handleInputChange}
                    readOnly={selectedRequest.status === "Approved"}
                  />
                  <MdDateRange className="input-icon" />
                </div>
              </label>
              <label className="input-with-icon">
                Approve Time:
                <div className="input-icon-wrapper">
                  <input
                    type="text"
                    name="approvedTime"
                    value={selectedRequest.approvedTime || ''}
                    onChange={handleInputChange}
                    readOnly={selectedRequest.status === "Approved"}
                  />
                  <MdAccessTime className="input-icon" />
                </div>
              </label>
              <label className="input-with-icon">
                Amount:
                <div className="input-icon-wrapper">
                  <input 
                    type="text" 
                    value={
                      (() => {
                        const numericValue = parseFloat(selectedRequest.customerValue);
                        return isNaN(numericValue) ? "" : `€ ${ (numericValue * 0.005).toFixed(2) }`;
                      })()
                    } 
                    readOnly 
                  />
                  {/* <MdAttachMoney className="input-icon" /> */}
                </div>
              </label>
              <label className="input-with-icon">
                  Status:
                  <div className="input-icon-wrapper">
                    <Select
                      name="status"
                      value={{ value: selectedRequest.status, label: selectedRequest.status }}
                      options={[
                        { value: 'Approved', label: 'Approved' },
                        { value: 'Awaiting', label: 'Awaiting' }
                      ]}
                      onChange={(option) => {
                        const now = new Date();
                        const currentDate = now.toISOString().split("T")[0].replace(/-/g, "/");
                        const currentTime = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

                        setSelectedRequest((prev) => ({
                          ...prev,
                          status: option.value,
                          approvedDate: option.value === "Approved" ? currentDate : prev.approvedDate,
                          approvedTime: option.value === "Approved" ? currentTime : prev.approvedTime,
                        }));
                      }}
                      classNamePrefix="custom-select"
                      styles={{
                        control: (base, state) => ({
                          ...base,
                          border: '1.17px solid rgba(209, 209, 209, 1)',
                          borderRadius: '7px',
                          background: 'rgba(253, 253, 253, 1)',
                          minHeight: '35px',
                          boxShadow: state.isFocused ? '0 0 0px rgba(21, 21, 22, 0.4)' : 'none',
                          '&:hover': 'none',
                          fontSize: '15px',
                          color:'rgba(105, 105, 105, 1)',
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          padding: '0 8px',
                        }),
                        singleValue: (base) => ({
                          ...base,
                          // color: '#000',
                          color:'rgba(105, 105, 105, 1)',
                        }),
                        placeholder: (base) => ({
                          ...base,
                          color:'rgba(105, 105, 105, 1)',
                        }),
                        menu: (base) => ({
                          ...base,
                          backgroundColor: '#fff',
                          borderRadius: '6px',
                          marginTop: '2px',
                          zIndex: 9999,
                        }),
                        option: (base, { isSelected, isFocused }) => ({
                          ...base,
                          backgroundColor: isSelected
                            ? '#e6f0ff'
                            : isFocused
                            ? '#e6f0ff'
                            : '#fff',
                          color: isSelected ? '#000' : '#000',
                          cursor: 'pointer',
                        }),
                      }}
                    />
                    {/* <MdOutlineModeEditOutline className="input-icon" /> */}
                  </div>
                </label>

              <label className="input-with-icon">
                Notes:
                <div className="input-icon-wrapper">
                  <textarea
                    placeholder="Enter note here"
                    name="note"
                    value={selectedRequest.note || ''}
                    onChange={handleInputChange}
                  ></textarea>
                  <MdOutlineModeEditOutline className="input-icon" />
                </div>
              </label>

              <div className="modal-buttons">
                <button className="update-btn" onClick={handleUpdate}>
                  Update
                </button>
                <button className="cancel-btn" onClick={handleCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  )
}

export default AgentCashRequestHistory